import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { initKeycloak } from './utils/keycloak';
import { UIBox, UITypography, UIButton } from '@workspace/ui/composed';
import { t } from './i18n';

const root = ReactDOM.createRoot(document.getElementById('root')!);

// Show loading state
const showLoading = () => {
  root.render(
    <UIBox className="flex flex-col justify-center items-center h-screen gap-4">
      <UIBox className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      <UITypography variant="p" className="text-lg">
        {t('common.initializing')}
      </UITypography>
    </UIBox>
  );
};

// Show error state
const showError = (message: string) => {
  root.render(
    <UIBox className="flex flex-col justify-center items-center h-screen gap-4">
      <UITypography variant="p" className="text-lg text-destructive">
        {t('common.authenticationError')}
      </UITypography>
      <UITypography variant="muted">{message}</UITypography>
      <UIButton variant="default" onClick={() => window.location.reload()}>
        {t('common.retry')}
      </UIButton>
    </UIBox>
  );
};

showLoading();

// Initialize Keycloak and render app
initKeycloak(
  () => {
    root.render(
      <React.StrictMode>
        <App />
      </React.StrictMode>
    );
  },
  (error: Error) => {
    showError(error.message || t('common.authInitFailed'));
  }
);
